import React, { useState } from 'react';
import copyToClipboard from '../node_modules/copy-to-clipboard/index.js';

function useCopyToClipboard() {
  const [copiedText, setCopiedText] = useState(null);
  const copy = React.useCallback((text, args) => {
    try {
      const res = copyToClipboard(text);
      if (res) {
        setCopiedText(text);
        args?.onSuccess?.();
        return true;
      } else {
        throw new Error("Copy failed");
      }
    } catch (error) {
      console.warn("Copy failed", error);
      setCopiedText(null);
      return false;
    }
  }, []);
  return [
    copiedText,
    copy
  ];
}

export { useCopyToClipboard as default };
//# sourceMappingURL=useCopyToClipboard.js.map
